import { render, staticRenderFns } from "./FeebbackFormItem.vue?vue&type=template&id=493d3293&scoped=true&"
import script from "./FeebbackFormItem.vue?vue&type=script&lang=js&"
export * from "./FeebbackFormItem.vue?vue&type=script&lang=js&"
import style0 from "./FeebbackFormItem.vue?vue&type=style&index=0&id=493d3293&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493d3293",
  null
  
)

export default component.exports